import { BASIC_STORAGE_LIMIT, FREE_STORAGE_LIMIT, paddleSubscriptionTrials } from '../constants';
import { computed } from 'vue';

export default function usePlans(betaPhaseManager) {
  const basic = 'basic';
  const free = 'free';

  const getPrice = (plan) => {
    switch (plan) {
      case free:
        return 'Free';
      case basic:
        return '$3';
      default:
        return '';
    }
  };

  const betaBenefits = computed(() => {
    if (betaPhaseManager.isInBeta.value) {
      return [
        { text: 'AI powered property prefills (only during beta phase)' },
        { text: 'Configurable page blocks (only during beta phase)' },
      ];
    }

    return [];
  });

  const plans = computed(() => ({
    free: {
      id: free,
      icon: { src: '/app/illustrations/free-plan.svg' },
      title: 'Free',
      subTitle: 'Capture and Organize Web Content - For Free!',
      price: getPrice(free),
      terms: [' '],
      isHighlighted: false,
      storageLimit: FREE_STORAGE_LIMIT,
      productId: import.meta.env.VITE_FREE_PADDLE_PRODUCT_ID,
      benefits: [
        ...betaBenefits.value,
        { text: '1 Notion workspace' },
        { text: '50 Mb storage for your screenshots' },
        { text: 'Limited to 50 captures per month' },
        { text: 'Save screenshots to Notion' },
        { text: 'Define custom properties to pre-fill on Notion pages' },
        { text: 'Edit the body of pages before sending it to Notion' },
      ],
    },
    basic: {
      id: basic,
      icon: { src: '/app/illustrations/basic-plan.svg' },
      title: 'Basic',
      subTitle: 'Upgrade Your Notion Workflow with AI-powered Features',
      price: getPrice(basic),
      terms: ['per month'],
      isHighlighted: true,
      benefits: [
        { text: 'All features in the Free plan' },
        { text: 'Unlimited Notion workspaces' },
        { text: '1 Gb storage for your screenshots' },
        { text: 'Unlimited captures per month' },
        { text: 'AI-powered pre-filling of Notion properties based on webpage content' },
      ],
      productId: import.meta.env.VITE_BASIC_PADDLE_PRODUCT_ID,
      storageLimit: BASIC_STORAGE_LIMIT,
      prices: {
        [paddleSubscriptionTrials.trial]: import.meta.env.VITE_BASIC_PADDLE_MONTHLY_TRIAL_PRICE_ID,
        [paddleSubscriptionTrials.noTrial]: import.meta.env.VITE_BASIC_PADDLE_MONTHLY_PRICE_ID,
      },
    },
  }));

  return { plans };
}
